// Miroir frontend de backend/config/jobFamilies.js (slugs + fallback FR).
// Labels EN/ES via i18n (forms:experience.job_family.<slug>), fallback FR sinon.
// Propager tout ajout/retrait dans backend/config/jobFamilies.js.

export const JOB_FAMILY_VALUES = [
  'general_management',
  'sales',
  'business_development',
  'customer_success',
  'marketing',
  'communications',
  'product',
  'engineering',
  'information_technology',
  'data_ai',
  'design',
  'operations',
  'supply_chain',
  'finance',
  'human_resources',
  'legal_compliance',
  'consulting',
  'research',
  'education',
  'healthcare',
  'administration',
  'other',
]

export const JOB_FAMILY_LABELS = {
  general_management: 'Direction générale',
  sales: 'Vente / Commercial',
  business_development: 'Business Development',
  customer_success: 'Customer Success / Relation client',
  marketing: 'Marketing',
  communications: 'Communication',
  product: 'Produit',
  engineering: 'Ingénierie / Développement',
  information_technology: 'IT / Systèmes & Réseaux',
  data_ai: 'Data / IA',
  design: 'Design / UX',
  operations: 'Opérations',
  supply_chain: 'Supply Chain / Logistique',
  finance: 'Finance / Comptabilité',
  human_resources: 'Ressources Humaines',
  legal_compliance: 'Juridique / Conformité',
  consulting: 'Conseil',
  research: 'Recherche / R&D',
  education: 'Enseignement / Formation',
  healthcare: 'Santé / Soin',
  administration: 'Administration / Support',
  other: 'Autre',
}

export const getJobFamilyLabel = (slug, t) => {
  if (!slug) return ''
  if (t) return t(`forms:experience.job_family.${slug}`, { defaultValue: JOB_FAMILY_LABELS[slug] || slug })
  return JOB_FAMILY_LABELS[slug] || slug
}

export const isValidJobFamily = (value) =>
  value === null || value === undefined || value === '' || JOB_FAMILY_VALUES.includes(value)
